var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasinoLimitFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.124 3a7.475 7.475 0 00-.624 3c0 1.607.506 3.097 1.367 4.317a1.688 1.688 0 101.815 1.816A7.466 7.466 0 0018 13.5a7.474 7.474 0 003-.624V20a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h7.124zm6.047 11.784a1.688 1.688 0 10-2.387 2.388 1.688 1.688 0 002.387-2.388zM9.216 6.83a1.688 1.688 0 10-2.387 2.388 1.688 1.688 0 002.387-2.388z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0a6 6 0 110 12 6 6 0 010-12zm0 8a.75.75 0 100 1.5.75.75 0 000-1.5zm0-5.45a.75.75 0 00-.75.75v3a.75.75 0 001.5 0v-3a.75.75 0 00-.75-.75z",
    fill: "currentColor"
  })));
}
SvgCasinoLimitFilled.displayName = 'CasinoLimitFilled';
export default SvgCasinoLimitFilled;